import React, { Component } from 'react';
import {
  Portlet,
  PortletBody,
  PortletHeader,
  PortletHeaderToolbar
} from "../../../partials/content/Portlet";
import { Container, Row, Col, Card, Badge, Button, Form, Modal } from 'react-bootstrap';
import { Formik } from 'formik';
import { MyPropertiesServices } from './MyPropertes.services';
import UltimatePagination from '../../../partials/layout/PaginationComponent';
import { formatMultipleUsers, formatAmount, formatDate } from '../../../../_metronic/utils/utils';
import { Link } from 'react-router-dom';
import * as constants from '../../../constants';
import { debounce } from 'throttle-debounce';
import FilterComponent from '../../../partials/layout/FilterComponent';
import { commonServices } from '../../../../app/commonServices/commonServices';
import * as firebase from 'firebase/app';

export default class MyProperties extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      showAboutModal: false,
      page: 1,
      total: undefined,
      offset: 0,
      limit: 10,
      requestedFilters: [
        'propertyManagementStatus', 'pmsSubscriptionType'
      ],
      propertyManagementStatus: ['YES']
    }
  }

  /**
   * component did mount method
   */
  async componentDidMount() {
    await this.getCities();
    await this.getAllProperties();
    await this.getPropertyManagersMoveinManagerAndSalesManager();
  }

  /**
   * Method to get property managers
   */
  getPropertyManagersMoveinManagerAndSalesManager = async () => {
    const data = {
      userRoleCodes: ['PROPERTY_MANAGER', 'SALES_MANAGER', 'MOVE_IN_MANAGER'],
    }
    const result = await commonServices.getUserListData(data);
    if (result && result.status === 200) {
      const propertyManagers = result.data.users.filter(user =>
        user.userRoleCodes?.includes("PROPERTY_MANAGER")
      );
      const salesManagers = result.data.users.filter(user =>
        user.userRoleCodes?.includes("SALES_MANAGER")
      );
      const moveInManagers = result.data.users.filter(user =>
        user.userRoleCodes?.includes("MOVE_IN_MANAGER")
      );
      await this.setState({ propertyManagers: propertyManagers, salesManagers: salesManagers, moveInManagers: moveInManagers })
    }
  }

  /**
   * Method to get all the cities
   */
  getCities = async () => {
    const { cityIds } = this.state;
    const data = {
      pmsOperationStatus: 'YES'
    }
    const result = await commonServices.getCities(data);
    if (result && result.status === 200) {
      const cities = result?.data?.cities;
      const formattedCities = commonServices.formatCities(cities);
      let preSelectedCities = null;
      if (this.state.cityIds?.length > 0) {
        preSelectedCities = commonServices.preSelectCities(formattedCities, cityIds);
      }
      this.setState({ formattedCities });
      preSelectedCities && this.setState({ preSelectedCities });
    }
  }

  /**
   * component will mount method
   */
  componentWillMount() {
    this.getAllProperties = debounce(
      800,
      this.getAllProperties
    )
  }

  /**
   * Method to get all the payments data
   */
  getAllProperties = async () => {
    this.setState({ isFetching: true });
    const { offset, limit, searchQuery, propertyManagementStatus, prevQuery, cityIds,
      propertyManagerId, salesManagerId, beatsListingIdentifier, pmsSubscriptionType, moveInManagerId, pmsCollectionMode, leaseStatus, task, taskStatus, propertyReadinessStatus, expMoveinFromDate, expMoveinToDate } = this.state;
    const data = {
      searchQuery,
      cityIds,
      propertyManagerId: propertyManagerId !== '0' ? propertyManagerId : undefined,
      salesManagerId: salesManagerId !== '0' ? salesManagerId : undefined,
      moveInManagerId: moveInManagerId !== '0' ? moveInManagerId : undefined,
      propertyManagementStatus: (!searchQuery && !beatsListingIdentifier) ? (propertyManagementStatus && propertyManagementStatus[0]) || undefined : undefined,
      // propertyManagerAssigned: 'FALSE',
      include: ['LATEST_LEASE_MOVE_IN_MANAGER', 'CURRENT_RENT', 'PROPERTY_MANAGER', 'SALES_MANAGER', 'OCCUPANCY_STATUS', 'CURRENT_TENANTS', 'LATEST_LEASE', 'OWNERS', 'PMS_SUBSCRIPTIONS'],
      offset,
      limit,
      scope: ( searchQuery || beatsListingIdentifier ) ? 'ALL' : null,
      beatsListingIdentifier,
      minimumExclusiveFeeRateQuantity: pmsSubscriptionType && pmsSubscriptionType.includes("Paid") ? 0 : undefined,
      maximumFeeRateQuantity: pmsSubscriptionType && pmsSubscriptionType.includes("Free") ? 0 : undefined,
      pmsCollectionMode: pmsCollectionMode !== '' ? pmsCollectionMode : undefined,
      leaseStatus: leaseStatus !== [] ? leaseStatus : undefined,
      task: task !== [] ? task : undefined,
      taskStatus: taskStatus !== '' ? taskStatus : undefined,
      propertyReadinessStatus: propertyReadinessStatus !== '' ? propertyReadinessStatus : undefined,
      expMoveinFromDate: expMoveinFromDate !== '' ? expMoveinFromDate : undefined,
      expMoveinToDate: expMoveinToDate !== '' ? expMoveinToDate : undefined
    }
    const result = await MyPropertiesServices.getAllProperties(data);
    if (result && result.status === 200) {
      const totalCount = result.headers['x-total-count'];
      const totalPageNo = Math.ceil(totalCount / limit);
      await this.setState({
        myProperties: result.data.houses,
        total: totalPageNo === 0 ? 1 : totalPageNo,
        totalCount
      });
      (prevQuery !== searchQuery) && await this.resetPage();
      await this.setState({ prevQuery: searchQuery })
    }
    this.setState({ isFetching: false });
  }

  /**
   * method to handle page change for pagination
   * @param {*} page
   */
  onPageChange = async (page) => {
    const { limit } = this.state;
    const offset = (limit * (page - 1));
    await this.setState({ page, offset });
    await this.getAllProperties();
  }

  /**
   * Method to get the property status badge
   * @param {String} status 
   */
  getPropertyStatusBadge(status) {
    return status === 'OCCUPIED' ? <Badge variant="success" title="Occupied">O</Badge> : <Badge variant="warning" title="Vacant">V</Badge>
  }

  /**
   * Method to handle data of add payment component
   * @param {String} childData
   */
  handleFilterChildData = async (childData) => {
    if (childData) {
      this.setState({ ...childData })
      await this.resetPage();
      await this.getAllProperties();
      await this.getCities();
      await this.getPropertyManagersMoveinManagerAndSalesManager();
      firebase.analytics().logEvent("apply_filter_button_click", { description: "Apply Filter Button Clicked", filterComponent: 'My Properties' });
    }
  }

  /**
   * Method to reset Pagination
   */
  resetPage = async () => {
    await this.setState({
      page: 1,
      offset: 0,
      // limit: 10,
    })
  }
  /** 
   * Method to handling Info Modal
   */
  handleAboutModal = async(id)=>{
    this.setState(state => ({showAboutModal: !state.showAboutModal}));
    const response = this.state.myProperties.find((item)=> item.id === id);
    this.setState(
      {details: response?.taskStatus, 
      house: response?.formattedHouseName
      });
  }

  render() {
    const { total, totalCount, page, myProperties, isFetching, searchQuery,
      requestedFilters, propertyManagementStatus, formattedCities, preSelectedCities,
      propertyManagers, salesManagers, propertyManagerId, pmsSubscriptionType, moveInManagerId, moveInManagers} = this.state;
    if (searchQuery) {

    }
    let showPagination = false;
    if (total) { showPagination = total !== 0 && total !== 1; }
    return (

      <>
        <Container fluid>
          <Portlet fluidHeight={true}>
            <PortletHeader title={`My Properties (${totalCount || 0})`}
              toolbar={
                <PortletHeaderToolbar>
                  <Formik
                    initialValues={{
                      searchQuery: undefined
                    }}
                    onSubmit={
                      async (values, { setSubmitting }) => {
                        if (values.searchQuery && values.searchQuery.length > 2) {
                          await this.setState({ searchQuery: values.searchQuery })
                          setTimeout(() => {
                            this.getAllProperties();
                          });
                        } else if ((!values.searchQuery) || (values.searchQuery && values.searchQuery.length < 2)) {
                          await this.setState({ searchQuery: undefined })
                          setTimeout(() => {
                            this.getAllProperties();
                          });
                        }
                      }

                    }
                  >
                    {
                      ({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) =>
                      (
                        <Form className="py-2">
                          <Form.Text id="searchHelpText" muted>Search by Property Name or by Customer's Name, Email or Phone Number or by TCF ID</Form.Text>
                          <Form.Control className="d-inline" type="text" name="searchQuery" placeholder="Type to search..." value={values.searchQuery}
                            onChange={
                              (e) => {
                                handleSubmit(e);
                                handleChange(e);
                              }
                            }
                          />
                        </Form>
                      )
                    }
                  </Formik>
                  <span className="px-2">OR</span>
                  <Formik
                    initialValues={{
                      beatsListingIdentifier: undefined
                    }}
                    onSubmit={
                      async (values, { setSubmitting }) => {
                        if (values.beatsListingIdentifier && values.beatsListingIdentifier.length > 2) {
                          await this.setState({ beatsListingIdentifier: values.beatsListingIdentifier })
                          setTimeout(() => {
                            this.getAllProperties();
                          });
                        } else if ((!values.beatsListingIdentifier) || (values.beatsListingIdentifier && values.beatsListingIdentifier.length < 2)) {
                          await this.setState({ beatsListingIdentifier: undefined })
                          setTimeout(() => {
                            this.getAllProperties();
                          });
                        }
                      }
                    }>
                    {
                      ({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) =>
                      (
                        <Form className="py-2">
                          <Form.Text id="BeatsHelpText" muted>Search using Beats Listing ID.</Form.Text>
                          <Form.Control className="d-inline" type="text" name="beatsListingIdentifier" placeholder="Type to search..." value={values.beatsListingIdentifier}
                            onChange={
                              (e) => {
                                handleSubmit(e);
                                handleChange(e);
                              }
                            }
                          />
                        </Form>
                      )}
                  </Formik>
                </PortletHeaderToolbar>
              }
            />
            <PortletBody>
              <Card>
                <FilterComponent
                  moveInManagers= {moveInManagers}
                  moveInManagerId ={moveInManagerId}
                  formattedCities={formattedCities}
                  preSelectedCities={preSelectedCities}
                  requestedFilters={requestedFilters}
                  propertyManagers={propertyManagers}
                  salesManagers={salesManagers}
                  propertyManagerId={propertyManagerId}
                  recordsPerPage={constants.RECORDS_PER_PAGE}
                  selectedRecordValue={this.state.limit}
                  filterParentCallback={this.handleFilterChildData}
                  propertyManagementStatus={propertyManagementStatus}
                  pmsSubscriptionType={pmsSubscriptionType}
                  isMyProperties={true} />
                <Card.Header>
                  <Row className="azuro-table-header">
                    <Col md={3}><strong>Property</strong></Col>
                    <Col md={2}><strong>Owner</strong></Col>
                    <Col md={2}><strong>Tenant</strong></Col>
                    <Col md={2}><strong>Current Rent</strong></Col>
                    <Col md={2}><strong>Move-in Date</strong></Col>
                  </Row>
                </Card.Header>
                <Card.Body className="p-0">
                  {/* {(isFetching || !myProperties) && <p className="m-3">{constants.LOADING_DATA}</p>} */}
                  {(isFetching || !myProperties) && <div  className="d-flex justify-content-center align-items-center"><img src='/media/files/loader.gif' alt='Loading...' /></div>}
                  {!isFetching &&
                    <>
                      {myProperties && myProperties.length === 0 && <p>{constants.ZERO_DATA}</p>}
                      {myProperties && myProperties.length > 0 && myProperties.map(property =>
                        <React.Fragment key={property.id}>
                          <Row key={property.id} className="azuro-table-rowd-flex align-items-center px-3 py-2">
                            <Col md={3} className="d-flex flex-row"><span className="pr-3">{this.getPropertyStatusBadge(property.occupancyStatus || 'CLOSED')}</span>
                              <span>{property.formattedHouseName} <br />
                                {property.propertyManager ? <span className="small text-muted">PM: {property.propertyManager && property.propertyManager.fullName}</span> : <span className="small text-warning">PM: Not Assigned</span>}
                                <br />
                                {property.salesManager ? <span className="small text-muted">SM: {property.salesManager && property.salesManager.fullName}</span> : <span className="small text-warning">SM: Not Assigned</span>}
                              </span>
                              <div>
                                <Button size='sm' variant='clean' onClick={()=>this.handleAboutModal(property.id)}><i className="flaticon-information text-info fw-bold"></i></Button>
                              </div>
                            </Col>
                            <Col md={2}>
                              {formatMultipleUsers((property.owners) || [])}
                            </Col>
                            <Col md={2}>
                              {formatMultipleUsers((property.currentTenants) || [])}
                            </Col>
                            <Col md={2}>{formatAmount(property.currentRent, property.currency)}</Col>
                            <Col md={2} className="" >
                              <span>{property.latestLease && property.latestLease.moveInDate ? formatDate(property.latestLease.moveInDate) : 'Not Set'}<br />
                                {property.propertyManagementStatus === 'YES' ? <span className="small text-success">Under Management</span> : property.propertyManagementStatus === 'NO' ? <span className="small text-danger">Not Under Management</span> : <span className="small text-muted">Status Not Set</span>}</span>
                            </Col>
                            <Col md={1}>
                              <Link to={`/property-profile/${property.id}`}>
                                <Button size='sm' variant='clean'><i className="flaticon-home-1 text-primary"></i></Button>
                              </Link>
                            </Col>
                            <Col md={12}>
                              <hr className="my-1" />
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                      {/* Code for pagination */}
                      {!isFetching && showPagination && showPagination && <UltimatePagination
                        currentPage={page}
                        totalPages={total}
                        onChange={this.onPageChange}
                        boundaryPagesRange={0}
                        hidePreviousAndNextPageLinks={true}
                        hideFirstAndLastPageLinks={page !== 1 && page !== total ? false : true}
                      />}
                    </>
                  }
                </Card.Body>
              </Card>
            </PortletBody>
          </Portlet>
        </Container>
        {this.state.showAboutModal && <Modal show={this.state.showAboutModal} onHide={this.handleAboutModal} backdrop="false" centered size='lg'>
          <Modal.Header closeButton className='border-0'>
            <Modal.Title className='border-0'>
              <div>
                <h5 className="mb-1 font-weight-bold">Property Details</h5>
                <small className="text-muted font-weight-bold">
                  {this.state.house}
                </small>
              </div>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="p-0">

            <Row className="m-0">
              <Col md={6} className="p-0">

                <div className="d-flex justify-content-between align-items-center px-3 py-3 ">
                  <span>Background Verification Report</span>
                  <span className={`badge ${this.state?.details?.BACKGROUND_VERIFICATION_REPORT === true ? "badge-success" : "badge-danger"}  rounded-circle p-2`}>{this.state?.details?.BACKGROUND_VERIFICATION_REPORT === true? "✓" : "✕"}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center px-3 py-3 ">
                  <span>Move in Report</span>
                  <span className={`badge ${this.state?.details?.MOVE_IN_REPORT === true ? "badge-success" : "badge-danger"}  rounded-circle p-2`}>{this.state?.details?.MOVE_IN_REPORT === true ? "✓" : "✕"}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center px-3 py-3">
                  <span>Tenant Documents</span>
                  <span className={`badge ${this.state?.details?.TENANT_DOCUMENTS === true ? "badge-success" : "badge-danger"}  rounded-circle p-2`}>{this.state?.details?.TENANT_DOCUMENTS === true ? "✓" : "✕"}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center px-3 py-3">
                  <span>PMS Subscription</span>
                  <span className={`badge ${this.state?.details?.PMS_SUBSCRIPTION === true ? "badge-success" : "badge-danger"}  rounded-circle p-2`}>{this.state?.details?.PMS_SUBSCRIPTION === true ? "✓" : "✕"}</span>
                </div>

              </Col>
              <Col md={6} className="p-0">
                <div className="d-flex justify-content-between align-items-center px-3 py-3 ">
                  <span>Owner Documents</span>
                  <span className={`badge ${this.state?.details?.OWNER_DOCUMENTS === true ? "badge-success" : "badge-danger"}  rounded-circle p-2`}>{this.state?.details?.OWNER_DOCUMENTS === true ? "✓" : "✕"}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center px-3 py-3 ">
                  <span>Lease Agreement</span>
                  <span className={`badge ${this.state?.details?.LEASE_AGREEMENT === true ? "badge-success" : "badge-danger"}  rounded-circle p-2`}>{this.state?.details?.LEASE_AGREEMENT === true ? "✓" : "✕"}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center px-3 py-3 ">
                  <span>Police Verification</span>
                  <span className={`badge ${this.state?.details?.POLICE_VERIFICATION === true ? "badge-success" : "badge-danger"}  rounded-circle p-2`}>{this.state?.details?.POLICE_VERIFICATION === true ? "✓" : "✕"}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center px-3 py-3">
                  <span>Home Insurance</span>
                  <span className={`badge ${this.state?.details?.HOME_INSURANCE === true ? "badge-success" : "badge-danger"}  rounded-circle p-2`}>{this.state?.details?.HOME_INSURANCE === true ? "✓" : "✕"}</span>
                </div>
              </Col>
            </Row>
            <Col xs={16} className="text-right">
              <Button variant="secondary" className="mr-2 border-0" onClick={this.handleAboutModal}>
                Close
              </Button>
            </Col>
          </Modal.Body>
        </Modal>
      }
      </>
    )
  }

}
